export enum SessionStorageKeys {
  noContact = 'noContact',
  fts_intersection_observer = 'fts_intersection_observer',
  addressStorage = 'addressStorage',
}
